<template>
  <div>
    <v-row>
      <v-col v-if="isEditingProfile">
        <mf-info-card
          variant="warning"
          icon="warning"
          description="Alterar o perfil vai redefinir as permissões de acesso às páginas e aos dados sensíveis de acordo com os novos perfis selecionados."
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="this.$getLoggedUser().ecommerce_url.length ? 6 : 12" class="py-0">
        <v-container fluid class="pa-0">
          <span class="d-block mt-2 custom-title-font">CBM</span>
          <div class="cbm-checkboxs">
            <v-checkbox
              v-for="profile in profilesPages"
              :key="profile.value"
              v-model="selectedProfiles"
              :value="profile.value"
              hide-details
              single-line
              dense
              color="marca-0"
              :error="userObject.profiles ? userProfileError : profileError"
              @change="userChangedSelection"
            >
              <template v-slot:label>
                <span class="field-text">{{ profile.text }}</span>
              </template>
            </v-checkbox>
          </div>

          <div v-if="userObject.profiles">
            <div v-if="userProfileError" class="v-messages theme--light error--text mt-1" role="alert">{{ profilesErrorMessages }}</div>
          </div>
          <div v-else>
            <div v-if="profileError" class="v-messages theme--light error--text mt-1" role="alert">{{ notProfilesErrorMessages }}</div>
          </div>
        </v-container>
      </v-col>
      <v-divider v-if="this.$getLoggedUser().ecommerce_url.length" vertical />
      <v-col v-if="this.$getLoggedUser().ecommerce_url.length" cols="5" class="py-0">
        <v-container fluic class="pa-0">
          <span class="d-block mt-2 custom-title-font">E-commerce</span>

          <div class="ecommerce-checkboxs">
            <v-checkbox
              v-for="profile in getEcommerce"
              :key="profile.value"
              v-model="selectedEcommerces"
              :value="profile.value"
              hide-details
              single-line
              dense
              color="marca-0"
              :error="userObject.ecommerce ? userEcommerceError : ecommerceError"
            >
              <template v-slot:label>
                <span v-if="!isAdminLast || profile.text !== 'Administrador'" class="field-text">{{ profile.text }}</span>
                <v-tooltip v-else right>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <span class="field-text">Administrador</span>
                      <v-icon small class="pl-2">info_outline</v-icon>
                    </div>
                  </template>
                  <span>Todas as permissões</span>
                </v-tooltip>
              </template>
            </v-checkbox>
          </div>

          <div v-if="userObject.ecommerce">
            <div v-if="userEcommerceError" class="v-messages theme--light error--text mt-1" role="alert">{{ ecommerceErrorMessages }}</div>
          </div>
          <div v-else>
            <div v-if="ecommerceError" class="v-messages theme--light error--text mt-1" role="alert">{{ notecommerceErrorMessages }}</div>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { profilesPages } from '../../mixins/user-profiles'

export default {
  name: 'AccessProfile',
  components: {},
  mixins: [profilesPages],
  props: {
    isCreateUser: {
      type: Boolean,
      default: false,
    },
    isAdminLast: {
      type: Boolean,
      default: false,
    },
    profileError: {
      type: Boolean,
      default: false,
    },
    ecommerceError: {
      type: Boolean,
      default: false,
    },
    userProfileError: {
      type: Boolean,
      default: false,
    },
    userEcommerceError: {
      type: Boolean,
      default: false,
    },
    colLength: {
      type: Number,
      default: 4,
    },
    profiles: {
      type: Array,
      required: true,
    },
    ecommerce: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    selectedProfiles: [],
    selectedEcommerces: [],
    initialProfilesSelection: [],
  }),
  computed: {
    profilesErrorMessages() {
      if (this.userProfileError) return 'Campo obrigatório'
      return ''
    },
    notProfilesErrorMessages() {
      if (this.profileError) return 'Campo obrigatório'
      return ''
    },
    ecommerceErrorMessages() {
      if (this.userEcommerceError) return 'Campo obrigatório'
      return ''
    },
    notecommerceErrorMessages() {
      if (this.ecommerceError) return 'Campo obrigatório'
      return ''
    },
    userObject: {
      get() {
        return this.user
      },
      set(value) {
        this.$emit('update:user', value)
      },
    },
    profileArray: {
      get() {
        return this.profile
      },
      set(value) {
        this.$emit('update:profile', value)
      },
    },
    ecommerceArray: {
      get() {
        return this.ecommerce
      },
      set(value) {
        this.$emit('update:ecommerce', value)
      },
    },
    getEcommerce() {
      if (this.isAdminLast) {
        const newEcommerce = [].concat(this.ecommerceProfiles)
        newEcommerce.push(newEcommerce.shift())

        return newEcommerce
      }

      return this.ecommerceProfiles
    },
    isEditingProfile() {
      return this.initialProfilesSelection && this.initialProfilesSelection.length > 0
    },
  },
  watch: {
    selectedProfiles() {
      this.selectedEcommerces = this.user.ecommerce ?? []
      const filteredProfiles = this.profilesPages.filter((profile) => this.selectedProfiles.includes(profile.value)) ?? []

      if (this.userObject.profiles) {
        this.userObject.profiles = filteredProfiles

        return
      }

      this.profileArray = filteredProfiles
    },
    selectedEcommerces() {
      if (this.userObject.ecommerce) {
        this.userObject.ecommerce = this.selectedEcommerces

        return
      }

      this.ecommerceArray = this.selectedEcommerces
    },
  },
  created() {
    if (this.userObject.profiles) {
      this.selectedProfiles = this.userObject.profiles.map((profile) => profile.value)
      this.initialProfilesSelection = [...this.selectedProfiles]

      return
    }

    this.selectedProfiles = this.profileArray.map((profile) => profile.value)
    this.initialProfilesSelection = [...this.selectedProfiles]
  },
  methods: {
    clearFields() {
      this.selectedProfiles = []
      this.selectedEcommerces = []
      this.initialProfilesSelection = []
    },
    userChangedSelection() {
      const filteredProfiles = this.profilesPages.filter((profile) => this.selectedProfiles.includes(profile.value)) ?? []
      this.$emit('change', filteredProfiles)
    },
  },
}
</script>

<style lang="scss">
.custom-title-font {
  color: $cinza-d10;
  font-weight: 700;
  font-size: 14px;
}

.field-text {
  font-size: 14px;
}

.cbm-checkboxs,
.ecommerce-checkboxs {
  display: grid;
  column-gap: 12px;
}

.cbm-checkboxs {
  grid-template-columns: 1fr 1fr 1fr;
}

.ecommerce-checkboxs {
  grid-template-columns: 1fr 1fr;
}
</style>
